import { Table } from '../../Table';
import useTable from '../../../hooks/useTable';
import { TableComponentProps } from '../types';

const columnLables = {
  unencumbered_cash: {
    name: 'Value of unencumbered cash',
    order: 207,
    letter: 'A'
  }
};

export function LiquidityProfiles2({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.PORTFOLIO_LIQUIDITY_PROFILE,
    onChangeFund,
    schema: schema.PORTFOLIO_LIQUIDITY_PROFILE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.PORTFOLIO_LIQUIDITY_PROFILE?.field_names || [],
    columnLables,
    isMultiFunds,
    tableName: 'PORTFOLIO_LIQUIDITY_PROFILE',
    funds
  });

  return (
    <Table
      id="fca-reporttables-liquidity-profiles-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
